import qs from 'qs'

const fields = [
  'title',
  'titleSingular',
  'locale'
]

const populate = ((options: queryOptions) => {
  return {
    richText: true,
    images: true,
    educationPageEntries: {
      filters: {
        biennialEntry: {
          slug: {
            $eq: options.slug
          }
        }
      },
      fields: ['title', 'slug'],
      populate: {
        biennialEntry: {
          fields: ['title', 'slug', 'editionIndex'],
          populate: {
            colors: '*'
          }
        },
        blocks: {
          on: {
            'blocks.images': {
              fields: ['richText'],
              populate: {
                files: {
                  populate: '*'
                }
              }
            },
            'blocks.rich-text': {
              fields: ['richText', 'richTextTruncated'],
            }
          }
        }
      }
    }
  }
})

// NOTE mirrors queryEducationPage
export const queryEducationPageCategoriesByBiennialSlug = (options: queryOptions) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'en-US',
      sort: ['title:asc'],
      filters: {
        educationPageEntries: {
          biennialEntry: {
            slug: {
              $eq: options.slug
            }
          }
        }
      },
      fields: fields,
      populate: populate(options),
    },
    {
      encodeValuesOnly: true
    }
  )

  return `education-category-entries?${query}`
}
